"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentsHeader = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _reactTransitionGroup = require("react-transition-group");

var _SearchInputHeader = _interopRequireDefault(require("../SearchInputHeader"));

var _Tabs = _interopRequireWildcard(require("../Tabs"));

var ContactAttachments = function ContactAttachments(_ref) {
  var _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
      _ref$defaultActiveTab = _ref.defaultActiveTab,
      defaultActiveTab = _ref$defaultActiveTab === void 0 ? 0 : _ref$defaultActiveTab,
      _ref$onChangeActiveTa = _ref.onChangeActiveTab,
      onChangeActiveTab = _ref$onChangeActiveTa === void 0 ? _noop["default"] : _ref$onChangeActiveTa,
      children = _ref.children;

  var _useState = (0, _react.useState)(defaultActiveTab),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  function handleChange(e, newValue) {
    setActiveTab(newValue);
    onChangeActiveTab(newValue);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      zIndex: 5
    }
  }, /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    value: activeTab,
    onChange: handleChange,
    variant: "scrollable"
  }, tabs.map(function (each, index) {
    return /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
      label: each.label,
      key: each.label,
      value: index
    });
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-app flex-grow flex h-full"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.SwitchTransition, {
    mode: "out-in"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    key: activeTab,
    addEndListener: function addEndListener(node, done) {
      node.addEventListener('transitionend', done, false);
    },
    classNames: "fade"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-full"
  }, children(activeTab))))));
};

var _default = ContactAttachments;
exports["default"] = _default;

var AttachmentsHeader = function AttachmentsHeader(_ref2) {
  var onKeywordChange = _ref2.onKeywordChange,
      avatar = _ref2.avatar;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_SearchInputHeader["default"], {
    onChange: onKeywordChange,
    accountAvatar: avatar
  }, t('contactDetail.attachments.title'));
};

exports.AttachmentsHeader = AttachmentsHeader;
//# sourceMappingURL=index.js.map